import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 404  -  旋转图片
 */

export default class EventRotatePic extends EventBase {
  /**
   * 构造函数
   */
  constructor() {
    super()
    this.Parameter = ['1', '0', '30', '0', '0', '0', '0', '', '', '0']
  }

  // #region 事件内关键属性参数
  /**
   * 图片ID
   */
  get PicId() {
    return parseInt(this.Parameter?.[0] ?? '')
  }
  set PicId(value) {
    this.Parameter && (this.Parameter[0] = value.toString())
  }

  /**
   * 旋转时间是否为数值（1是； 0否）
   */
  get RationTimeValueOrNot() {
    return parseInt(this.Parameter?.[1] ?? '')
  }
  set RationTimeValueOrNot(value) {
    this.Parameter && (this.Parameter[1] = value.toString())
  }

  /**
   * 旋转时间或指定数值；非数值指定时固定存储为帧数。
   */
  get RationTime() {
    return Number(this.Parameter?.[2] ?? '0')
  }
  set RationTime(value) {
    this.Parameter && (this.Parameter[2] = value.toString())
  }

  /**
   * 旋转角度是否为数值（1是； 0否）
   */
  get RationAngleValueOrNot() {
    return parseInt(this.Parameter?.[3] ?? '')
  }
  set RationAngleValueOrNot(value) {
    this.Parameter && (this.Parameter[3] = value.toString())
  }

  /**
   * 4	旋转角度 旋转角度
   */
  get RationAngle() {
    return Number(this.Parameter?.[4] ?? '0')
  }
  set RationAngle(value) {
    this.Parameter && (this.Parameter[4] = value.toString())
  }

  /**
   * 5	是否循环（1是； 0否）
   */
  get CirculationOrNot() {
    return parseInt(this.Parameter?.[5] ?? '')
  }
  set CirculationOrNot(value) {
    this.Parameter && (this.Parameter[5] = value.toString())
  }

  /**
   * 6	围绕点旋转	（0：中心点，1：左上角，10：自定义）
   */
  get PointRate() {
    return parseInt(this.Parameter?.[6] ?? '')
  }
  set PointRate(value) {
    this.Parameter && (this.Parameter[6] = value.toString())
  }

  /**
   * 7	旋转点 （x,y）
   */
  get RotationPoint() {
    return this.Parameter?.[7] || ''
  }
  set RotationPoint(value) {
    this.Parameter && (this.Parameter[7] = value)
  }

  /**
   * 事件ID
   */
  Code = EventID.RotatePic

  /**
   * 获得该事件在事件列表的描述信息
   */
  get Description() {
    return this.Parameter?.[8] || ''
  }
  set Description(value) {
    this.Parameter && (this.Parameter[8] = value.toString())
  }

  /**
   * 编辑器显示单位：0=帧，1=秒；非数值指定时 RationTime 固定存帧数。
   * 启用数值指定后 Type 固定为 0（帧），变量值在运行时按帧解释。
   */
  get Type() {
    return parseInt(this.Parameter?.[9] ?? '0')
  }

  set Type(value) {
    this.Parameter && (this.Parameter[9] = value.toString())
  }

  public GetParameter() {
    return this.Parameter
  }
}
// #endregion
